import React, { useEffect, useState } from 'react';
import { TextField, Button, Typography, Box, Container, Paper } from '@mui/material';
import { BrowserRouter, Route, Routes, Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import Config from '../Config.json';
import axios from "axios";
import { useBookContext } from "../contexts/bookContext";

function Register() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const { userData, isLogin, updateUserInfo, actions } = useBookContext();


    useEffect(() => {
        checkLogin();
    }, [userData]);

    const checkLogin = () => {
        if (isLogin()) {
            navigate('/home');
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        // Handle login logic here (e.g., API call for authentication)
        console.log('register submitted:', { email, password });
        register();
    };


    const register = async () => {

        try {

            const reqData = {};
            reqData.userEmail = email;
            reqData.userPhone = phone;
            reqData.userName = name;
            reqData.userPW = password;


            let response = await axios.post("/api/booking/Register", reqData);
            //            console.log("login result :" + JSON.stringify(response.data))
            if ((response.data.code === 0)) {
                let userInfo = response.data.result;
                var newData = {}
                newData.userEmail = userInfo.userEmail;
                newData.userPhone = userInfo.userPhone;
                newData.userName = userInfo.userName;
                newData.chargeMoney = userInfo.chargeMoney;
                newData.chargeCount = userInfo.chargeCount;
                newData.bonusCount = userInfo.bonusCount;
                newData.unlimitUser = userInfo.unlimitUser;

                updateUserInfo(newData);
                console.log("register save new userdata")
                //                checkLogin();


            }
        } catch (err) {
            console.error(err);
        }

    }

    return (
        <Container component="main" maxWidth="xs">
            <Paper elevation={3} sx={{ marginTop: 10, padding: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Typography component="h1" variant="h5">
                    회원가입
                </Typography>
                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="이메일"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="phone"
                        label="핸드폰번호 (- 없이)" 
                        name="phone"
                        autoComplete="phone"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="name"
                        label="이름"
                        name="name"
                        autoComplete="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="패스워드"
                        id="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        disabled={email.length > 0 && password.length > 0 && phone.length > 0 && name.length > 0 ? false : true}
                        sx={{ mt: 3, mb: 2 }}
                    >
                        회원가입
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
}

export default Register;